import createAction from '../../services/create-action';
export const MEDIA_STUDIO_OPENED = 'mediaStudio/OPENED';
export const mediaStudioOpened = createAction(MEDIA_STUDIO_OPENED);
export const RCE_FILE_UPLOADED = 'rce/FILE_UPLOADED';
export const fileUploaded = createAction(RCE_FILE_UPLOADED);
export const RCE_FILE_DOWNLOADED = 'rce/FILE_DOWNLOADED';
export const fileDownloaded = createAction(RCE_FILE_DOWNLOADED);
//# sourceMappingURL=bi-actions.js.map